import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { resetOrder } from '../../actions/currentOrder';

const initialState = false;

const slice = createSlice({
  name: '$ageProofSubmitted',
  initialState,
  reducers: {
    setAgeProofSubmitted(state, action: PayloadAction<boolean>) {
      return action.payload;
    },
  },
  extraReducers: builder => {
    builder.addCase(resetOrder, (_state, _action) => {
      return initialState;
    });
  },
});

export const { setAgeProofSubmitted } = slice.actions;

export default slice.reducer;
